// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"dd8dadd5","681":"529f2068","815":"63b3591d","849":"5c05f286"}[chunkId] + ".chunk.js";
};